module.exports = __webpack_public_path__ + "img/login-image.239c35b4.png";